import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { SnackBarService } from '@shared/services/snack-bar.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ErrorService } from '@shared/services/error.service';
import { datadogLogs } from '@datadog/browser-logs';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  private snackbarService = inject(SnackBarService);
  private errorService = inject(ErrorService);

  intercept<T>(
    request: HttpRequest<T>,
    next: HttpHandler
  ): Observable<HttpEvent<T>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        this.errorService.handleError(error.error);

        console.info('error intercepted:', error);
        datadogLogs.logger.error('HTTP Error', error);
        return throwError(() => error);
      })
    );
  }
}
